



















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import dayjs from "dayjs";
import LoadingOverlay from "@/resources/components/LoadingOverlay.vue";
import BaseModal from "@/resources/components/BaseModal.vue";
import Station from "@/app/models/Station";
import Debounce from "@/app/support/Debounce";
import Division from "@/app/models/Division";
import MultiSelect from "@/resources/components/MultiSelect.vue";
import { cloneDeep } from "lodash";
import StorageAttachment from "@/app/support/StorageAttachment";

@Component({
    components: { MultiSelect, BaseModal, LoadingOverlay },
})
export default class Edit extends Vue {
    @Prop({ required: true }) station!: Station;
    originalAttachments: StorageAttachment[] = [];
    divisions: Division[] = [];

    get templateDate() {
        return dayjs(this.station.template_date).format('YYYY-MM-DD');
    }

    getFileName(file: StorageAttachment|File): string {
        if (file instanceof File) {
            return file.name;
        }
        return file.filename;
    }

    set templateDate(templateDate: string) {
        this.updateTemplateDate(templateDate);
    }

    @Debounce(1000)
    updateTemplateDate(templateDate: string) {
        this.station.template_date = dayjs(templateDate).format('YYYY-MM-DD');
    }

    get workInstructionsFileName() {
        return this.station.work_instruction_name || null;
    }

    get stationDivisionAsArray() {
        return this.station.division_id != null ? [this.station.division_id.toString()] : [];
    }

    set stationDivisionAsArray(value: string[]) {
        this.station.division_id = value.length > 0 ? parseInt(value[0]) : null;
    }

    onAttachmentsChanged(e: InputEvent) {
        const target = e.target as HTMLInputElement;
        const files = Array.from(target.files ?? []);

        files.forEach(file => {
            this.station.attachments!.push(file);
        });
    }

    async removeAttachment(file: StorageAttachment|File) {
        if (file instanceof File) {
            this.station.attachments = this.station.attachments.filter((attachment: StorageAttachment|File) => attachment !== file) ?? [];
        } else {
            // Remove local attachment
            const originalAttachmentIndex = this.originalAttachments.findIndex((attachment: StorageAttachment) => attachment.filename === file.filename);

            if (originalAttachmentIndex !== -1) {
                await file.destroy();

                this.originalAttachments.splice(originalAttachmentIndex, 1);
                // @ts-ignore
                this.station.attachments = this.station.attachments.filter((attachment: StorageAttachment|File) => 
                    !(attachment instanceof File) && attachment.filename !== file.filename
                ) ?? [];
            }
        }
    }

    onWorkInstructionsChanged(e: InputEvent) {
        const target = e.target as HTMLInputElement;
        const file = target.files?.item(0);

        if (file != null) {
            this.station.work_instructions = file;
            this.station.work_instruction_name = file.name;
        }
    }

    @Watch('station.attachments', {deep: true, immediate: true})
    onStationChanged() {
        this.originalAttachments = cloneDeep(this.station.attachments ?? []).map((attachment: any) => new StorageAttachment(attachment));
    }

    async mounted() {
        // @ts-ignore
        this.divisions = (await Division.index()).data;
    }

    async submit() {
        this.task(() => this.station.save())
            .then(() => this.close());
    }

    close() {
        // @ts-ignore
        this.$parent.reset();
        this.$router.push({ name: 'questions.index', params: { station: this.station.id!.toString() } })
    }
}
